export default {
  root: {
    '&$focused': {
      color: 'inherit',
    },
  },
};
